import React, { useCallback, useMemo } from 'react';
import { message } from 'antd';
import ActionMenuV2 from 'components/ActionMenuV2';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { PermissionSetMap } from 'constants/RBACConstants';
import { CellRenderers } from 'utils/tableUtils';
import TableContainer from 'components/TableContainer';
// import ThreatConnectConfigForm from './ThreatConnectConfigForm';
const actions = [
//     {
// 	type: "edit",
// 	permission: PermissionSetMap.EDIT_TOOL_CONFIG,
// },
 {
	type: "delete",
	permission: PermissionSetMap.DELETE_TOOL,
}];

function ThreatConnectListing({data, onUpdateConfigComponent, ...props}) {
    const onDelete = useCallback((id) => {
		return ToolsIntegrationsAPI.deleteCTIConfiguration(id).promise.then((res) => {
			message.success(res);
			onUpdateConfigComponent();
		}).catch(err => message.error(err));
	}, [onUpdateConfigComponent]);

    //update API is not available
    //disable edit actions temporarily
    const onActionClick = useCallback(async (e, { name, data }) => {
		switch (name) {
			// case "edit":
			// 	ModalUtil.show({
			// 		content: <ThreatConnectConfigForm data={data} />,
			// 		afterClose: (success) => success && onUpdateConfigComponent()
			// 	})
			// 	break;
			case "delete":
				await onDelete(data.id);
				break;
			default:
				break;
		}
	}, [onDelete]);

	const columns = useMemo(()=>(
		[{
			title: "Name",
			dataIndex: "name",
			key: "name",
		}, ...(props.name === "ThreatConnect" ? [{
			title: "URL",
			dataIndex: "hostUrl",
			key: "hostUrl",
			render: CellRenderers.VALUE_OR_NA
		}] : []), {
			title:"Action",
			render: (record) => <ActionMenuV2 items={actions} onClick={onActionClick} data={record}/>
		}]), [onActionClick, props.name]);
		
	return (<TableContainer dataSource={props.loginConfigList} columns={columns}/>)
}

export default ThreatConnectListing